module.exports = __webpack_public_path__ + "static/media/imagesConfirm.f6ed079d.svg";